import { useEffect, useState } from "react"
import {
  useGetOrgActiveTechniquesAndInterventionsQuery,
  useGetAllActiveNudgesQuery,
} from "../generated/graphql"
import { prepareTechniquesAndInterventionsDataTable } from "../utils/helpers"
import { TechniquesAndInterventionsTableData } from "../utils/types"
import { useGraphQLClient } from "./useGraphQLClient"
import { useUser } from "./useUser"

export const useTechniquesAndInterventions = () => {
  const { user } = useUser()
  const [techniquesAndInterventions, setTechniquesAndInterventions] = useState<
    TechniquesAndInterventionsTableData[]
  >([])
  const graphQLClient = useGraphQLClient()
  let { data: allTechniquesData, refetch: refetchAllTechniques } =
    useGetAllActiveNudgesQuery(graphQLClient)
  let { data: orgTechniquesData, refetch: refetchOrgTechniques } =
    useGetOrgActiveTechniquesAndInterventionsQuery(graphQLClient, {
      org_id: user.organizations?.[0].id ?? -1,
      //cant call hook conditionally like we can on mobile side.
      //using a default (non-exisent) uuid to pull if user is unavailable
      user_id: user.id ?? "123e4567-e89b-12d3-a456-426614174000",
    })
  useEffect(() => {
    let data
    if (!user.email) return
    if (user?.email.endsWith("@ksanahealth.com")) {
      data = prepareTechniquesAndInterventionsDataTable(
        allTechniquesData?.nudges ?? [],
        user
      )
    } else {
      data = prepareTechniquesAndInterventionsDataTable(
        orgTechniquesData?.nudges ?? [],
        user
      )
    }
    setTechniquesAndInterventions(user ? data : [])
  }, [
    setTechniquesAndInterventions,
    allTechniquesData?.nudges,
    orgTechniquesData?.nudges,
    user,
  ])

  return {
    techniquesAndInterventions,
    refetchOrgTechniques,
    refetchAllTechniques,
  }
}
